enum ActionsTypes {
    SET_FILTER_ITEMS = 'SET_FILTER_ITEMS',
    APPEND_FILTER_ITEMS = 'APPEND_FILTER_ITEMS',
    SET_PRODUCT = 'SET_PRODUCT',
    DELETE_PRODUCT = 'DELETE_PRODUCT',
}

export type ActionType = keyof typeof ActionsTypes;

export default ActionsTypes;
